import { createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";

import * as service from "../services/facilityService";
import * as utils from "../utils/utilities";

const slice = createSlice({
  name: "facilities",
  initialState: {
    loading: false,
    error: false,
    lastUpdated: null,
    facilities: [],
  },
  reducers: {
    facilitiesRequested: (state, action) => {
      state.loading = true;
    },
    facilitiesRequestSuccess: (state, action) => {
      state.facilities = action.payload;
      state.loading = false;
      state.error = false;
    },
    facilitiesRequestFailed: (state, action) => {
      state.loading = false;
      state.error = true;
    },
    updateSyncTime: (state, action) => {
      state.lastUpdated = Date.now();
    },
  },
});

export const loadFacilities = () => async (dispatch, getState) => {
  try {
    dispatch(slice.actions.facilitiesRequested());

    const result = await service.getAll();

    dispatch(slice.actions.facilitiesRequestSuccess(result.data));
    dispatch(slice.actions.updateSyncTime());
  } catch (ex) {
    const cachedFacilities = utils.getCachedDataFromException(ex);
    if (!cachedFacilities)
      return dispatch(slice.actions.facilitiesRequestFailed());

    dispatch(slice.actions.facilitiesRequestSuccess(cachedFacilities));
  }
};

export const getFacilities = createSelector(
  (state) => state,
  (state) => state.facilities
);

export default slice.reducer;
